import React, { useEffect, useRef } from 'react'
import * as echarts from 'echarts';
const GraphCard = ({ option = {}, height='250px', onChartClick }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const chartInstance = echarts.init(chartRef.current);
    chartInstance.setOption(option);

    const handleResize = () => chartInstance.resize();
    window.addEventListener('resize', handleResize);

    if (onChartClick) {
      chartInstance.on('click', (params) => onChartClick(params));
    }

    return () => {
      window.removeEventListener('resize', handleResize);
      chartInstance.dispose();
    };
  }, [option])
  
  return (
    <div ref={chartRef} className="chart-canvas" style={{ height, cursor: onChartClick ? 'pointer' : 'default' }} />
  )
}

export default GraphCard